<template
  v-loading="loading"
  element-loading-text="正在导出中"
  element-loading-spinner="el-icon-loading"
  element-loading-background="rgba(0, 0, 0, 0.8)"
>
  <div class="app-container">
    <el-tabs v-model="listQuery.status" type="card" @tab-click="SearchData">
      <el-tab-pane label="全部" name="all"></el-tab-pane>
      <el-tab-pane label="待付款" name="1"></el-tab-pane>
      <el-tab-pane label="已付款" name="2"></el-tab-pane>
      <el-tab-pane label="已完成" name="3"></el-tab-pane>
      <el-tab-pane label="已退款" name="5"></el-tab-pane>
      <el-tab-pane label="已取消" name="6"></el-tab-pane>
    </el-tabs>

    <!--查询过滤-->
    <div class="filter-container" style="display: inline-boock; float: right; width: 90%">
      <el-form ref="queryForm" inline :model="listQuery" @submit.native.prevent>
        <el-form-item prop="site_id">
          <el-select v-model="listQuery.site_id" class="filter-item" clearable filterable placeholder="请选择门店名称">
            <el-option v-for="item in siteArray" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="site_id">
          <div
            class="block"
            style="
                    display: inline-block;
                    margin-bottom: 10px;
                    vertical-align: middle;
                "
          >
            <el-date-picker v-model="listQuery.search_time" type="daterange" range-separator="~" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
            </el-date-picker>
          </div>
        </el-form-item>
        <el-form-item prop="pay_type">
          <el-select v-model="listQuery.pay_type" class="filter-item" clearable filterable placeholder="请选择支付方式">
            <el-option label="微信支付" value="1"></el-option>
            <el-option label="余额支付" value="2"></el-option>
            <el-option label="套餐支付" value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="type">
          <el-select v-model="listQuery.type" class="filter-item" clearable filterable placeholder="请选择订单类型">
            <el-option v-for="item in typeArray" :key="item.id" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="search">
          <el-input v-model="listQuery.search" placeholder="请输入用户姓名" clearable style="width: 200px" class="filter-item" @keyup.enter.native="SearchData" />
        </el-form-item>
        <el-button class="filter-item" type="primary" icon="el-icon-search" @click="SearchData">搜索</el-button>
      </el-form>
    </div>
    <!-- <div class="span_distance">
      <span title="不包含已取消订单">有效订单：<el-icon class="el-icon-warning-outline"> </el-icon></span>
      <span>订单数: <strong>{{ statistics.count_order }}</strong>单</span>
      <span>订单总额:<strong>{{ statistics.order_money }}</strong>元</span>
      <span>折扣总额:<strong>{{ statistics.coupon_money }}</strong>元</span>
      <span>实付总额:<strong>{{ statistics.money }}</strong>元</span>
    </div> -->
    <!-- <el-button class="filter-item" type="success" icon="el-icon-download" @click="OutData">批量导出</el-button> -->
    <!-- 文字提示 -->
    <!-- <div style="padding: 5px 0">
        <span style="color: #f35e5e">导出操作会根据搜索条件查询进行,不加条件则导出所有生成的订单信息</span>
      </div> -->
    <!-- </div> -->
    <el-table ref="singleTable" v-loading="listLoading" :data="list" border fit highlight-current-row style="width: 100%" @sort-change="sortChange">
      <!--列开始-->
      <!-- <el-table-column type="selection"></el-table-column> -->
      <el-table-column type="index" label="序号" width="55" :index="indexMethod" align="center" />
      <el-table-column align="center" prop="nickname" label="下单用户 "></el-table-column>
      <el-table-column align="center" prop="type" label="订单类型 ">
        <template slot-scope="scopes">
          {{ typeArrayItem(scopes.row.type).label }}
        </template>
      </el-table-column>
      <el-table-column align="center" prop="site_name" label="门店名称">
        <template slot-scope="scopes">
          {{ scopes.row.site_name || '--' }}
        </template>
      </el-table-column>
      <el-table-column align="center" prop="pay_type" label="支付方式 ">
        <template slot-scope="scopes">
          <el-tag v-if="scopes.row.pay_type == 1">微信支付</el-tag>
          <el-tag v-else-if="scopes.row.pay_type == 2">余额支付</el-tag>
          <el-tag v-else>套餐支付</el-tag>
        </template>
      </el-table-column>
      <el-table-column v-if="listQuery.status == 'all'" align="center" prop="status_name" label="订单状态 ">
        <template slot-scope="scopes">
          <span v-if="scopes.row.type == 1 && scopes.row.lists.length > 1">--</span>
          <span v-else>{{ scopes.row.status_name }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="total_price" label="订单总额 "> </el-table-column>
      <el-table-column align="center" prop="price" label="实付金额 "> </el-table-column>
      <el-table-column align="center" prop="discount_price" label="折扣金额 "> </el-table-column>
      <el-table-column align="center" prop="create_time" label="创建时间 "> </el-table-column>
      <el-table-column align="center" prop="" label="操作" width="200" class-name="action">
        <template slot-scope="scopes">
          <el-button v-auth="'Order.order_detail'" icon="el-icon-tickets" type="primary" size="mini" @click="Detail(scopes.row)">详情</el-button>
          <!-- <el-button v-auth="'Site.delete'"  icon="el-icon-delete" type="danger" size="mini" @click="RowDelete(scopes.row)">删除</el-button> -->
        </template>
      </el-table-column>
      <!--列结束-->
    </el-table>
    <!--分页-->
    <pagination v-show="total > 0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="loadData" />
  </div>
</template>
<script>
import api from '@/api/order/order' // 订单表
import Pagination from '@/components/Pagination' // 分页 给予 el-pagination 的二次封装
import commonList from '@/utils/commonList'
import site from '@/api/site/site' // 门店信息
export default {
  components: { Pagination },
  filters: {},
  mixins: [commonList],
  data() {
    return {
      // api接口方法
      api,
      // 额外过滤条件
      listQuery: {
        search: undefined,
        express_type: 0,
        search_time: [],
        user_id: null,
        status: 'all',
        page: 1,
        limit: 15, // 页大小
        order: 'DESC', // 默认排序方式,
        sort: 'id',
        pay_type: '',
        type: '' // 支付方式
      },
      loading: false,
      rules: {},
      check: false,
      siteArray: [], // 门店列表
      statistics: {
        count_order: 0,
        order_money: 0,
        coupon_money: 0,
        money: 0
      },
      typeArray: [
        { label: '场地', value: 1 },
        { label: '教练', value: 2 },
        { label: '会员卡', value: 3 },
        { label: '课程套餐', value: 4 },
        { label: '余额充值', value: 5 }
        // { label: "课程", value: 6 },
      ]
    }
  },
  // 详情页面的beforeRouteLeave钩子函数
  beforeRouteLeave(to, from, next) {
    if (to.name == 'OrderDetail') {
      this.$store.state.tagsView.cachedViews.push('OrderList')
    }
    next()
  },
  // list组价的activated钩子
  activated() {
    this.loadData() // 这是我们获取数据的函数
    this.$store.state.tagsView.cachedViews.length = 0
  },
  created() {
    this.loadData() // 页面加载创建时加载数据
    this.getSite() // 获取门店信息
    // this.getOrderStatistics() // 获取统计数据
  },
  methods: {
    Detail(data) {
      this.$router.push({ path: '/order/order_detail', query: { id: data.id }})
    },
    typeArrayItem(value) {
      // 使用find方法查找数组中的对象
      return this.typeArray.find(item => item.value === value)
    },
    // 查询方法
    SearchData() {
      this.listQuery.page = 1
      this.loadData()
      // this.getOrderStatistics()
    },
    // 获取统计数据
    getOrderStatistics() {
      api.getOrderStatistics(this.listQuery).then((res) => {
        this.statistics = res.data
      })
    },
    // 获取门店信息
    getSite() {
      site.getList().then((response) => {
        this.siteArray = response.data
      }).catch((error) => {
        console.error('获取数据失败:', error)
      })
    },
    // 批量导出
    OutData() {
      this.loading = true
      api.OutDataOrder(this.listQuery).then((res) => {
        this.loading = false
        window.open(res.data)
        this.$notify({
          title: '成功',
          message: '订单导出成功',
          type: 'success',
          duration: 2000
        })
      })
    },
    // 批量删除
    batchDelete() {
      const ids = this.getSelectId()
      if (ids.length > 0) {
        this.$confirm('确定要删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.api.Delete(ids).then((res) => {
            this.$notify({
              title: '成功',
              message: res.message,
              type: 'success'
            })
            this.loadData()
          })
        })
      } else {
        this.$message({
          message: '请选择要删除的订单！',
          type: 'warning'
        })
      }
    },
    getSelectId() {
      const ids = []
      this.list.forEach((res) => {
        if (res.checked) {
          ids.push(res.id)
        }
      })
      return ids
    }

  }
}
</script>

<style lang="scss" scoped>
.action-cell {
  width: 120px;
  .span-price {
    display: inline-block;
    padding: 5px;
  }
  .pay-price {
    color: green;
    font-weight: 600;
  }
  .refund-price {
    color: red;
    font-weight: 600;
  }
  .el-tag {
    margin-top: 5px;
  }
}
.el-range-separator {
  width: 10% !important;
}
// 订单列表页样式
.order-item {
  border-top: 1px solid #dfe6ec;
  border-left: 1px solid #dfe6ec;
  margin-bottom: 10px;
  font-size: 12px;
  color: #3c3c3c;
  .noborder {
    border-right-width: 0;
  }
  .goods-image {
    float: left;
  }
  .goods-info {
    margin-left: 90px;
    text-align: left;
    .goods-title {
      padding: 5px 0;
    }
  }
  .goods-spec {
    color: #9e9e9e;
    padding: 3px;
  }
  .el-link {
    font-size: 12px;
    color: #3c3c3c;
  }
  table {
    width: 100%;
    border-spacing: 0;
    thead {
      background-color: #dfe6ec;
    }
  }
  td {
    text-align: center;
    padding: 10px;
    border-bottom: 1px solid #dfe6ec;
    border-right: 1px solid #dfe6ec;
  }
  th {
    text-align: left;
    padding: 8px;
  }
}
.goods_detail {
  padding: 5px 0;
}
.span_distance {
  padding-bottom: 10px;
  display: inline-block;
  span {
    margin-right: 10px;
  }
}
</style>

